// @flow
import firebase from 'firebase/app';
import { IUser } from 'types';
import Store, { action } from '../store';
import gravatar from 'helpers/gravatar';

import {
  INIT_AUTH,
  SIGN_IN_SUCCESS,
  SIGN_OUT_SUCCESS,
  SIGN_IN_ERROR,
  ADMIN_STATUS_CHANGE
} from './constants';
import db from 'db';

export default class AuthStore extends Store {
  authenticated: boolean;
  id: string;
  email: string;
  photoUrl: string;
  error: firebase.auth.Error;
  lastSeen: Number;
  admin: boolean;

  isAuthenticated(): boolean {
    return this.authenticated;
  }

  isAdmin(): boolean {
    return this.admin;
  }

  getId(): string {
    return this.id;
  }

  getAuthError(): firebase.auth.Error {
    return this.error;
  }

  @action(ADMIN_STATUS_CHANGE)
  handleAdmin(e, admin) {
    this.admin = admin;
    this.emit();
  }

  @action(INIT_AUTH, SIGN_IN_SUCCESS)
  handleAuth(event: string, payload: IUser) {
    if (payload) {
      this.authenticated = true;
      this.id = payload.uid;
      this.lastSeen = payload.lastSeen;
      this.email = payload.email;
      this.displayName = payload.displayName;
      this.photoUrl = payload.photoURL || payload.photoUrl || gravatar(payload.email);
      delete this.error;
    } else {
      this.authenticated = false;
    }
    this.emit();
  }

  @action(SIGN_OUT_SUCCESS)
  handleSignOut() {
    delete this.authenticated;
    delete this.id;
    delete this.email;
    delete this.photoUrl;
    db.unwatchAll();
    this.emit();
  }

  @action(SIGN_IN_ERROR)
  handleAuthError(e, error: firebase.auth.Error) {
    this.error = error;
    this.emit();
  }
}
